function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import { translate, translateFieldName } from '../utils/helpers';
import { LANG } from '../utils/constant';
var initialState = {
  activeMenu: 'PRODUCTS',
  activeStep: 1
};

var MobileMenu = /*#__PURE__*/function (_Component) {
  _inherits(MobileMenu, _Component);

  var _super = _createSuper(MobileMenu);

  function MobileMenu(props) {
    var _this;

    _classCallCheck(this, MobileMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setActiveMenu", function (activeMenu) {
      _this.setState({
        activeMenu: activeMenu
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveStep", function (activeStep) {
      _this.setState({
        activeStep: activeStep
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveCategory", function (activeCategory) {
      _this.setState({
        activeCategory: activeCategory,
        activeSubCategory: _this.state.categories.find(function (category) {
          return category.id === activeCategory;
        }).sub_categories[0].id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveSubCategory", function (activeSubCategory) {
      _this.setState({
        activeSubCategory: activeSubCategory
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSubcategories", function (categoryId) {
      return _this.state.categories.find(function (category) {
        return category.id === categoryId;
      }).sub_categories;
    });

    _defineProperty(_assertThisInitialized(_this), "getSubSubcategories", function (subCategoryId) {
      return _this.state.categories.find(function (category) {
        return category.id === _this.state.activeCategory;
      }).sub_categories.find(function (subCategory) {
        return subCategory.id === subCategoryId;
      }).sub_sub_categories;
    });

    _defineProperty(_assertThisInitialized(_this), "closeMobileMenu", function () {
      _this.props.closeMobileMenu();

      setTimeout(function () {
        _this.setState(_objectSpread(_objectSpread({}, initialState), {}, {
          activeCategory: _this.state.categories[0].id,
          activeSubCategory: _this.state.categories[0].sub_categories[0].id
        }));
      }, 300);
    });

    _this.state = _objectSpread(_objectSpread({}, initialState), {}, {
      activeCategory: 0,
      activeSubCategory: 0,
      categories: [],
      families: [],
      sectors: []
    });
    _this.languageSwitcherRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var families = this.props.families;
      families = _orderBy(families, [function (family) {
        return _deburr(family.name.toLowerCase());
      }]).splice(0, 12);
      var sectors = this.props.sectors;
      sectors = _orderBy(sectors, [function (sector) {
        return _deburr(sector.name.toLowerCase());
      }]);
      var categories = this.props.categories.map(function (category) {
        category.sub_categories = _orderBy(category.sub_categories, [function (subCategory) {
          return _deburr(subCategory[translateFieldName('name')].toLowerCase());
        }]);
        category.sub_categories.map(function (subCategory) {
          subCategory.sub_sub_categories = _orderBy(subCategory.sub_sub_categories, [function (subSubCategory) {
            return _deburr(subSubCategory[translateFieldName('name')].toLowerCase());
          }]);
          return subCategory;
        });
        return category;
      });
      this.setState({
        families: families,
        sectors: sectors,
        categories: categories,
        activeCategory: categories[0].id,
        activeSubCategory: categories[0].sub_categories[0].id
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.languageSwitcherRef.current.innerHTML = LANG === 'fr' ? 'EN' : 'FR';
      this.languageSwitcherRef.current.href = document.querySelector('.wpml-ls-link') ? document.querySelector('.wpml-ls-link').href : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          activeCategory = _this$state.activeCategory,
          activeSubCategory = _this$state.activeSubCategory,
          categories = _this$state.categories,
          sectors = _this$state.sectors,
          families = _this$state.families;
      return categories.length ? /*#__PURE__*/React.createElement("div", {
        className: "mobile-menu ".concat(this.props.isOpen ? 'active' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "language"
      }, /*#__PURE__*/React.createElement("a", {
        ref: this.languageSwitcherRef,
        href: ""
      }), /*#__PURE__*/React.createElement("i", {
        onClick: this.closeMobileMenu,
        className: "fa fa-times",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step step1"
      }, /*#__PURE__*/React.createElement("div", {
        className: " menu-item ".concat(this.state.activeMenu === 'PRODUCTS' ? 'show' : 'hide'),
        onClick: function onClick() {
          return _this2.setActiveMenu('PRODUCTS');
        }
      }, translate('PRODUCTS', 'PRODUITS'), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-right"
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-sub-items ".concat(this.state.activeMenu === 'PRODUCTS' ? 'show' : 'hide')
      }, categories.map(function (category) {
        return category[translateFieldName('name')] ? /*#__PURE__*/React.createElement("div", {
          className: "category-link ".concat(activeCategory === category.id ? 'active' : ''),
          key: category.id,
          onClick: function onClick() {
            _this2.setActiveStep(2);

            _this2.setActiveCategory(category.id);
          }
        }, /*#__PURE__*/React.createElement("span", null, category[translateFieldName('name')]), /*#__PURE__*/React.createElement("i", {
          className: "fa fa-angle-up"
        })) : null;
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-item ".concat(this.state.activeMenu === 'INO' ? 'show' : 'hide'),
        onClick: function onClick() {
          return _this2.setActiveMenu('INO');
        }
      }, translate('INO LINES', 'LIGNES INO'), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-right"
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-sub-items ".concat(this.state.activeMenu === 'INO' ? 'show' : 'hide')
      }, /*#__PURE__*/React.createElement("div", {
        className: "logos-container"
      }, families.map(function (family, index) {
        return family.id && /*#__PURE__*/React.createElement("a", {
          key: index,
          className: "logo-container",
          href: "/".concat(LANG, "/shop/#/families/").concat(family.id, "/suppliers/1"),
          onClick: _this2.closeMobileMenu
        }, family.logo !== null ? /*#__PURE__*/React.createElement("div", {
          alt: family[translateFieldName('name')],
          className: "img-responsive  logo",
          style: {
            backgroundImage: 'url(' + family.logo + ')'
          }
        }) : null, /*#__PURE__*/React.createElement("span", null, family.name));
      }), /*#__PURE__*/React.createElement("div", {
        className: "d-flex w-100 align-items-center justify-content-center"
      }, /*#__PURE__*/React.createElement("a", {
        className: "all-suppliers-link ",
        href: "/".concat(LANG, "/").concat(translate('ino-lines', 'lignes-ino')),
        onClick: this.closeMobileMenu
      }, /*#__PURE__*/React.createElement("span", {
        className: "main-txt"
      }, translate('See all Ino families', 'Voir toutes les familles Ino')))))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item ".concat(this.state.activeMenu === 'SECTORS' ? 'show' : 'hide'),
        onClick: function onClick() {
          return _this2.setActiveMenu('SECTORS');
        }
      }, translate('SECTORS', 'SECTEURS'), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-right"
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-sub-items ".concat(this.state.activeMenu === 'SECTORS' ? 'show' : 'hide')
      }, /*#__PURE__*/React.createElement("div", {
        className: "logos-container sectors"
      }, sectors.map(function (sector) {
        return sector.name ? /*#__PURE__*/React.createElement("a", {
          href: "/".concat(LANG, "/").concat(sector.slug),
          key: sector.slug,
          className: "logo-container sectors-links",
          onClick: _this2.closeMobileMenu
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, sector.name)) : null;
      }))), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('resources-ino ', 'ressources-ino'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('RESOURCES', 'RESSOURCES')))), /*#__PURE__*/React.createElement("a", {
        href: "/shop/#/sds"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('SDS', 'FDS')))), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('about-us ', 'a-propos'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('ABOUT', 'À PROPOS')))), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('distributer-ino ', 'distributeur-ino'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('FIND YOUR LOCAL DISTRIBUTOR', 'TROUVER VOTRE DISTRIBUTEUR')))), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('news ', 'nouvelles'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('NEWS', 'NOUVELLES')))), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/").concat(translate('contact ', 'nous-joindre'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item sds"
      }, /*#__PURE__*/React.createElement("span", null, translate('CONTACT', 'NOUS JOINDRE'))))), /*#__PURE__*/React.createElement("div", {
        className: "menu-column  ".concat(this.state.activeStep >= 2 ? 'active' : '')
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "menu-item back",
        onClick: function onClick() {
          return _this2.setActiveStep(1);
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-left"
      }), translate('BACK', 'RETOUR')))), /*#__PURE__*/React.createElement("div", {
        className: "links-container"
      }, this.getSubcategories(activeCategory).map(function (subCategory) {
        return subCategory[translateFieldName('name')] ? /*#__PURE__*/React.createElement("div", {
          key: subCategory.id,
          className: "category-link ".concat(activeSubCategory === subCategory.id ? 'active' : ''),
          onClick: function onClick() {
            _this2.setActiveStep(3);

            _this2.setActiveSubCategory(subCategory.id);
          }
        }, /*#__PURE__*/React.createElement("span", null, subCategory[translateFieldName('name')]), /*#__PURE__*/React.createElement("i", {
          className: "fa fa-angle-right"
        })) : null;
      }))), /*#__PURE__*/React.createElement("div", {
        className: "menu-column ".concat(this.state.activeStep === 3 ? 'active' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item back",
        onClick: function onClick() {
          return _this2.setActiveStep(2);
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-left"
      }), translate('BACK', 'RETOUR'))), /*#__PURE__*/React.createElement("div", {
        className: "links-container"
      }, this.getSubSubcategories(activeSubCategory).map(function (subSubCategory) {
        return subSubCategory[translateFieldName('name')] ? /*#__PURE__*/React.createElement("div", {
          key: subSubCategory.id
        }, /*#__PURE__*/React.createElement("a", {
          className: "category-link ",
          href: "/".concat(LANG, "/shop/#/category/").concat(activeCategory, "+").concat(activeSubCategory, "+").concat(subSubCategory.id),
          onClick: _this2.closeMobileMenu
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, subSubCategory[translateFieldName('name')]))) : null;
      }))))) : null;
    }
  }]);

  return MobileMenu;
}(Component);

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  closeMobileMenu: PropTypes.func,
  categories: PropTypes.array,
  families: PropTypes.array,
  sectors: PropTypes.array,
  closeMenu: PropTypes.func
};
export default MobileMenu;